export type FishCropImageRequest = {
  size?: 'thumb' | 'small' | 'medium' | 'full';
  quality?: number;
  format?: 'jpeg' | 'webp';
};

type ToGatewayImageRouteArgs = {
  path: string;
  request?: FishCropImageRequest;
};

/**
 * Keeps image downloads on the configured gallery gateway and applies optional image transforms.
 */
export const toGatewayImageRoute = ({ path, request }: ToGatewayImageRouteArgs): string => {
  const route = toGatewayRoute(path);
  if (!request) return route;

  // Dummy origin so `new URL` can parse a relative route; only pathname+search are returned.
  const url = new URL(route, 'https://gallery-gateway.invalid');
  if (request.size) url.searchParams.set('size', request.size);
  if (request.quality) url.searchParams.set('quality', String(request.quality));
  if (request.format) url.searchParams.set('format', request.format);
  return `${url.pathname}${url.search}`;
};

/** Gateway-relative route so requests stay same-origin (and proxied locally). */
const toGatewayRoute = (path: string): string => {
  try {
    const parsed = new URL(path);
    return `${parsed.pathname}${parsed.search}`;
  } catch {
    return path.startsWith('/') ? path : `/${path}`;
  }
};
